import Route from '@ember/routing/route';
import { inject as service } from '@ember/service';

export default class DashboardDynamicViewIndexRoute extends Route {
  @service router;

  afterModel(model, transition) {
    if (transition.targetName === 'dashboard.dynamic-view.index') {
      this.router.transitionTo('dashboard.dynamic-view.keywords', model);
    }
  }
}
